import React from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { useStore } from '../../stores';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { TabBar } from '../../features/tabs/TabBar';
import { RequestBuilder } from '../../features/request-builder/RequestBuilder';
import { ResponseViewer } from '../../features/response-viewer/ResponseViewer';
import { usePresence } from '../../features/presence';

export function AppShell() {
  const { sidebarCollapsed, tabs, activeTabId } = useStore();
  const activeTab = tabs.find((t) => t.id === activeTabId);

  // Enable presence tracking - this automatically publishes editing state
  // when the active tab changes
  usePresence();

  return (
    <div className="h-screen flex flex-col bg-background">
      {/* Top Header */}
      <Header />

      {/* Main Content */}
      <div className="flex-1 flex overflow-hidden">
        <PanelGroup direction="horizontal" className="flex-1">
          {/* Sidebar */}
          {!sidebarCollapsed && (
            <>
              <Panel defaultSize={20} minSize={15} maxSize={40}>
                <Sidebar />
              </Panel>
              <PanelResizeHandle className="w-1 bg-border hover:bg-primary/20 transition-colors" />
            </>
          )}

          {/* Main Area */}
          <Panel defaultSize={80}>
            <div className="h-full flex flex-col">
              {/* Tab Bar */}
              <TabBar />

              {/* Request/Response Area */}
              {activeTab ? (
                <PanelGroup direction="vertical" className="flex-1">
                  {/* Request Builder */}
                  <Panel defaultSize={50} minSize={30}>
                    <RequestBuilder tab={activeTab} />
                  </Panel>

                  <PanelResizeHandle className="h-1 bg-border hover:bg-primary/20 transition-colors" />

                  {/* Response Viewer */}
                  <Panel defaultSize={50} minSize={20}>
                    <ResponseViewer tab={activeTab} />
                  </Panel>
                </PanelGroup>
              ) : (
                <div className="flex-1 flex items-center justify-center text-muted-foreground">
                  <p>Create or open a request to get started</p>
                </div>
              )}
            </div>
          </Panel>
        </PanelGroup>
      </div>
    </div>
  );
}
